export class BasicRequest{
    
    public requestorId! : number;
    public requestorEntityId? : number;
    public requestorEntityType? : string;
}